import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

const TRANSLATION_KEY = 'TheMicrocentrifuge.string';

export function Header(props) {
  const {t} = useTranslation();

  return <h2 className={props.className}>{t(TRANSLATION_KEY)}</h2>;
}

Header.PropTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

Header.defaultProps = {
  className: '',
  text: '',
};
